import React from 'react';
import Chart from 'react-apexcharts';
import './charts.css';
import './Indicateurs.css';

function CharPie({ series, options, title }) {
  // S'assurer que les données sont des nombres
  const numericSeries = series.map(val => typeof val === 'string' ? parseFloat(val) : val);
  // Calculer le total pour les pourcentages
  const totalValue = numericSeries.reduce((a, b) => a + b, 0);
  
  // Configuration par défaut pour le graphique
  const defaultOptions = {
    chart: {
      type: 'pie',
      fontFamily: 'Montserrat, sans-serif'
    },
    colors: ['var(--primary-green)', 'var(--primary-orange)', 'var(--secondary-green)', 'var(--accent-orange)'],
    labels: ['Amérique du Nord', 'Europe', 'Asie-Pacifique', 'Afrique'],
    legend: {
      show: false
    },
    dataLabels: {
      enabled: true,
      formatter: function(val, opts) {
        // Calculer et formater en pourcentage
        return val.toFixed(1) + '%';
      },
      style: {
        fontSize: '20px',
        fontWeight: '700',
        colors: ['#fff'],
        textShadow: '0px 1px 2px rgba(0,0,0,0.5)'
      },
      background: {
        enabled: true,
        foreColor: '#000',
        opacity: 0.7,
        borderWidth: 0,
        borderRadius: 4
      },
      dropShadow: {
        enabled: true,
        color: '#000',
        top: 1,
        left: 1,
        blur: 3,
        opacity: 0.3
      }
    },
    stroke: {
      width: 2,
      colors: ['#fff']
    },
    plotOptions: {
      pie: {
        customScale: 1,
        offsetY: 0,
        dataLabels: {
          offset: 0,
          minAngleToShowLabel: 10
        }
      }
    },
    tooltip: {
      enabled: true,
      fillSeriesColor: false,
      theme: 'dark',
      style: {
        fontSize: '14px'
      },
      y: {
        formatter: function(val) {
          // Afficher la valeur absolue et le pourcentage dans le tooltip
          const percent = ((val / totalValue) * 100).toFixed(1);
          return val.toLocaleString() + ' (' + percent + '%)';
        }
      }
    }
  };

  // Fusionner les options
  const mergedOptions = { ...defaultOptions, ...options };

  return (
    <div className="gov-card">
      <div className="gov-card-body">
        <h5 className="gov-card-title region-title">{title}</h5>
        <div className="region-distribution-container" style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
          <div className="region-chart" style={{ flex: '0 0 60%', maxWidth: '60%', marginRight: '10px' }}>
            <Chart
              options={mergedOptions}
              series={numericSeries}
              type="pie"
              width="100%"
              height="400px"
            />
          </div>
          
          <div className="region-stats" style={{ flex: '1', paddingLeft: '10px' }}>
            {numericSeries && numericSeries.length > 0 && mergedOptions.labels && (
              <ul className="region-stats-list" style={{ listStyle: 'none', padding: 0, margin: '15px 0' }}>
                {numericSeries.map((value, index) => (
                  <li key={index} className="region-stat-item" style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    marginBottom: '15px',
                    padding: '10px',
                    borderRadius: '8px',
                    boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
                    transition: 'all 0.3s ease',
                    backgroundColor: 'rgba(255, 255, 255, 0.8)'
                  }}>
                    <div className="region-stat-icon" style={{
                      backgroundColor: mergedOptions.colors[index % mergedOptions.colors.length],
                      width: '20px',
                      height: '20px',
                      borderRadius: '4px',
                      marginRight: '15px'
                    }}></div>
                    <div className="region-stat-info" style={{ flex: 1 }}>
                      <span className="region-stat-name" style={{ 
                        display: 'block', 
                        fontWeight: '600',
                        fontSize: '15px',
                        color: 'var(--secondary-green)',
                        marginBottom: '4px'
                      }}>{mergedOptions.labels[index]}</span>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span className="region-stat-value" style={{ 
                          fontWeight: 'bold',
                          color: 'var(--primary-green)',
                          fontSize: '18px'
                        }}>{value.toLocaleString()}</span>
                        <span className="region-stat-percent" style={{
                          backgroundColor: mergedOptions.colors[index % mergedOptions.colors.length],
                          color: 'white',
                          padding: '3px 10px',
                          borderRadius: '12px',
                          fontSize: '13px',
                          fontWeight: 'bold'
                        }}>
                          {((value / totalValue) * 100).toFixed(1)}%
                        </span>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CharPie;

